const ID = 'tag';

export default ID;
